import React from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select'


const optionLabelRenderer = (data, formatOptionLabelMeta) => {
  if (formatOptionLabelMeta.context == "menu") {
    return (<div key={data.label}>
      {data.label} <span className='pull-right'>{data.count} </span>
    </div>
    );
  } return (<div key={data.label}>
    {data.label}
  </div>
  );
};

class SearchableCheckboxList extends React.Component {
  constructor(props) {
    super(props);
    this._onChange = this._onChange.bind(this);
  }
  _onChange(newValue, actionMeta) {
    var values = newValue.map(function (obj) { return obj.value });
    this.props.onChange(values);
  }

  render() {

    var options = this.props.options.map(function (obj, i) {
      return {
        value: obj.Name,
        label: obj.Name,
        count: obj.Count
      };
    }.bind(this));

    var selectedOptions = [];
    if (this.props.selected) {
      for (let i = 0; i < options.length; i++) {
        const option = options[i];
        for (let selectedI = 0; selectedI < this.props.selected.length; selectedI++) {
          const selectedOption = this.props.selected[selectedI];
          if (selectedOption == option.value) {
            selectedOptions.push(option);
          }
        }
      }
    }

    return (
      <Select onChange={this._onChange} value={selectedOptions} placeholder="Search" options={options} className="basic-multi-select col-12" classNamePrefix="select" isMulti formatOptionLabel={optionLabelRenderer} styles={{
        menu: (baseStyles, state) => ({
          ...baseStyles,
          zIndex: 99,
        }),
      }} />
    );
  }
}
export default SearchableCheckboxList;

